import { Spinner } from '@/components/common/Spinner';
import Header from '@/components/header/Header';
import MyAccountWrapper from '@/components/myaccount/MyAccount';
import { SelectedPartnerContext } from '@/Contexts/SelectedPartnerContext';
import { SelectedProgramContext } from '@/Contexts/SelectedProgramContext';
import { UsersContext } from '@/Contexts/UsersContext';
import { UserType } from '@/models/User';
import { Box, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';

export default function MyAccount() {
  const theme = useTheme();
  const { userType, currentContact, userCurrent } = useContext(UsersContext);
  const { partnerInfo, partnerId, updatePartnerId } = useContext(SelectedPartnerContext);
  const { selectedProgramId, updateSelectedProgramId } = useContext(SelectedProgramContext);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (
      ((UserType.Applicant == userType && partnerInfo != null) || // Applicant && partnerInfo loaded
        userType != UserType.Applicant) && // Not Applicant
      currentContact != null
    ) {
      setLoading(false);
    }
  }, [partnerInfo, currentContact, userType]);

  useEffect(() => {
    if (partnerId == null && userCurrent.currentPartnerId != null) {
      const defaultPartnerId = userCurrent.currentPartnerId;
      if (defaultPartnerId != null) updatePartnerId(defaultPartnerId);
    }
  }, [partnerId, userCurrent.currentPartnerId, updatePartnerId]);

  useEffect(() => {
    if (partnerInfo?.programId != null && selectedProgramId != partnerInfo?.programId) {
      updateSelectedProgramId(partnerInfo.programId);
    }
  }, [partnerInfo?.programId, selectedProgramId, updateSelectedProgramId]);

  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100vh'
      width='100vw'
      style={{
        overflowX: 'hidden',
      }}
      bgcolor={`${theme.palette.sand.main}`}
    >
      <Header />
      {loading ? <Spinner /> : <MyAccountWrapper />}
    </Box>
  );
}
